// Keep this in sync with $mobile-viewport-cutoff in the styles
export const mobileViewportCutoff = 750;
